var React = require('react');

function AsanaHeadToKnee (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M1.113,21c0,0,6.012,0,9.012,0\n\tC11.89,21,13,22.261,13,24c0,1.732-1.173,3-2.938,3C9.188,27,7.25,27,6,27c-2,0-5-1-5-5c0-5.313,5.438-9,12.438-9\n\tc3.563,0,6.284,1.269,8.143,3.762c0.955,1.283,2.868,3.848,3.821,5.13C27.025,24.07,28.75,25,31,25c2,0,6,0,6,0v-7 M12.854,25h8.862\n\tl-2.977-3.997L14,21 M37,21.005h-6.537C30.805,20.415,31,19.73,31,19c0-2.209-1.791-4-4-4s-7.131,0-7.131,0"}));
}

AsanaHeadToKnee.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaHeadToKnee;

AsanaHeadToKnee.default = AsanaHeadToKnee;
